import { useQuery } from "@tanstack/react-query";
import { api, fileUrl } from "@/lib/api";
import { Loading, EmptyState } from "@/components/States";
import { FileText, Download } from "lucide-react";

export default function PublicationsView({ type, label }) {
  const { data, isLoading } = useQuery({
    queryKey: ["publications", type],
    queryFn: async () => (await api.get("/publications", { params: { type } })).data,
  });
  if (isLoading) return <Loading />;
  if (!data?.length) return <EmptyState icon={FileText} title={`Nenhum item em ${label}`} subtitle="A administração ainda não publicou nada aqui." />;
  return (
    <div className="space-y-3">
      {data.map((p) => (
        <div key={p.id} data-testid="publication-item" className="glass rounded-3xl p-4 card-hover">
          <div className="flex items-start gap-3">
            <FileText className="w-5 h-5 text-primary mt-0.5" />
            <div className="flex-1">
              <p className="font-display font-semibold text-sm">{p.title}</p>
              {p.description && <p className="text-xs text-muted-foreground mt-1 whitespace-pre-wrap">{p.description}</p>}
              {p.visibility === "individual" && <span className="inline-block mt-2 text-[10px] px-2 py-0.5 rounded-full bg-primary/15 text-primary">Individual</span>}
            </div>
            {p.file_url && (
              <a href={fileUrl(p.file_url)} target="_blank" rel="noreferrer" data-testid="publication-download" className="p-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"><Download className="w-4 h-4" /></a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
